import React from "react";
import "./Mission_Vision.css";
import { Container, Row, Col } from "react-bootstrap";

const Mission_Vision = () => {
  return (
    <section className="mission_vision">
      <Container>
        {/*MISSION SECTION*/}
        <Row>
          <div className="mission_row">
            <Col md={5}>
              <div className="image_holder">
                <img
                  src="/assets/images/about_us/mission_vision/vi.png"
                  alt="Our Mission"
                  className="section_image"
                />
              </div>
            </Col>

            <Col md={7}>
              <div className="text_col">
                <h1 className="section_title mission_title">Mission</h1>
                <h5 className="sub">Mission</h5>
                <div className="subsection">
                  <p className="tagline">
                    To inspire healthy living and promote sportsmanship through
                    accessible, inclusive, and fun fitness programs.
                  </p>
                  <p className="description">
                    Our mission is to provide professional and structured sports
                    and fitness training in a safe, motivating, and positive
                    environment. We focus on developing physical strength,
                    endurance, agility, and confidence through well-designed
                    training programs.
                  </p>
                  <p className="description">
                    We are committed to nurturing young athletes and helping
                    every child enjoy the journey of sports, fitness, and
                    personal growth.
                  </p>
                </div>
              </div>
            </Col>
          </div>
        </Row>

        <Row>
          <div className="vision_row">
            <Col md={5}>
              <div className="image_holder">
                <img
                  src="/assets/images/about_us/mission_vision/vi.png"
                  alt="Our Vision"
                  className="section_image"
                />
              </div>
            </Col>

            <Col md={7}>
              <div className="text_col">
                <h1 className="section_title vision_title">Vision</h1>
                <h5 className="sub">Vision</h5>
                <div className="subsection">
                  <p className="tagline">
                    To become the leading hub for sports, fitness, and wellness
                    — empowering people of all ages to move, compete, and
                    thrive.
                  </p>

                  <p className="description">
                    Our vision is to create a healthy and active community by
                    promoting sports and fitness for all age groups. We aim to
                    inspire children, youth, and adults to develop a lifelong
                    passion for physical activity and a healthy lifestyle.
                    Through quality training and guidance, we strive to build
                    confident, disciplined, and strong individuals.
                  </p>
                </div>
              </div>
            </Col>
          </div>
        </Row>
      </Container>
    </section>
  );
};

export default Mission_Vision;
